import { ReactElement } from 'react'
import {
    CheckoutActions,
    checkoutPaymentMethods,
    CheckoutState,
} from '@raskrask-dk/bookingflow-state-machine'
import { useBFSMValue } from '../../../services/hooks/useBFSMValues'
import PaymentMethodsTemplate from './template'

const PaymentMethodsPage = (): ReactElement => {
    const [paymentMethod, setPaymentMethod] = useBFSMValue<
        CheckoutState,
        CheckoutActions.ChoosePaymentMethod,
        'paymentMethod'
    >('paymentMethod', CheckoutActions.ChoosePaymentMethod)

    const paymentMethods = checkoutPaymentMethods

    return (
        <PaymentMethodsTemplate
            onClickPaymentMethod={setPaymentMethod}
            paymentMethods={paymentMethods}
            selectedPaymentMethod={paymentMethod}
        />
    )
}

export default PaymentMethodsPage
